import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { ResponseData } from 'request'
import {
  PaymentListItem,
  CancelPaymentOrderResponse,
  CancelPaymentOrder,
  GetPaymentRecordQuery,
  PaymentOrderListItem,
} from '@pt/api/payment/type'
import { AxiosPromise } from 'axios'
import { GrantPurchaseablePlan } from '@pt/api/grant/index.type'
import { cookRequestParams } from '@/common/request'

export function getPlans(): AxiosPromise<
  ResponseData<GrantPurchaseablePlan[]>
> {
  return request({
    url: `${v2Host}/buy/plans`,
    method: 'get',
  })
}

// 查询用户购买套餐的列表
export function getUserPaymentList(
  params: GetPaymentRecordQuery,
): AxiosPromise<ResponseData<PaymentListItem>> {
  console.log('params', params)
  return request({
    url: `${v2Host}/user/order/list`,
    method: 'get',
    params,
  })
}

export function cancelPaymentOrder(
  data: CancelPaymentOrder,
): AxiosPromise<ResponseData<CancelPaymentOrderResponse>> {
  return request({
    url: `${v2Host}/user/order/cancel`,
    method: 'post',
    data,
  })
}

// 后台订单列表
export function getPaymentOrderList(params: {
  page: number
  page_size: number
}): AxiosPromise<
  ResponseData<{
    list: PaymentOrderListItem[]
    total: number
  }>
> {
  return request({
    url: `${v2Host}/payment/order/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
